import { createGlobalStyle } from 'styled-components'
import "./Fonts.css"
export const GlobalStyle = createGlobalStyle`

*{
    font-family: 'SFProText';
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    
}
body{
    overflow-x: hidden;
}
`